import { render, staticRenderFns } from "./RememberForm.vue?vue&type=template&id=3b344074&"
import script from "./RememberForm.vue?vue&type=script&lang=js&"
export * from "./RememberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports